import React from 'react';

export { ExpiredLinkIcon } from '../icons';

type FeedbackWidgetProps = {
    icon: React.ReactNode;
    title: string;
    message: string;
};

export const FeedbackWidget: React.FC<FeedbackWidgetProps> = ({ icon, title, message }) => (
    <div style={{
        textAlign: 'center',
        backgroundColor: '#161616',
        borderRadius: '16px',
        padding: '40px 28px',
        color: '#ffffff',
        width: '100%',
    }}>
        <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'center' }}>
            {icon}
        </div>
        <h2 style={{ fontSize: '20px', fontWeight: 'bold', margin: '0 0 8px 0' }}>
            {title}
        </h2>
        <p style={{ fontSize: '14px', color: '#9ca3af', margin: 0 }}>
            {message}
        </p>
    </div>
);
